import { render } from "./InputCover.vue?vue&type=template&id=524470df&scoped=true"
import script from "./InputCover.vue?vue&type=script&lang=js"
export * from "./InputCover.vue?vue&type=script&lang=js"

import "./InputCover.vue?vue&type=style&index=0&id=524470df&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-524470df"]])

export default __exports__